import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Close icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/x?f=classic&s=solid
 */
export const CloseIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faXmark} {...props} />;
};
